import SectionCounter1 from "../../../sections/home/index/section-counter1";
import { useEffect } from "react";
import { loadScript, publicUrlFor } from "../../../../globals/constants";
import { FaChartLine, FaBullseye, FaFileAlt } from "react-icons/fa";
import { FaArrowUpRightDots } from "react-icons/fa6";
import { NavLink } from "react-router-dom";
import Seo from "../../common/Seo";

function DigitalMarketingServicePage() {
  useEffect(() => {
    loadScript("js/custom.js");
  }, []);

  return (
    <>
      <Seo
        title="Digital Marketing Company in Pune | SEO, PPC & Lead Generation"
        description="Grow your business online with result-driven digital marketing services. DArchTech offers SEO, PPC, social media & lead generation solutions."
      />

      {/* SERVICE DETAIL SECTION START */}
      <div className="section-full p-b80 sx-ser-detail-outer sx-bg-white">
        {/* Banner Section */}
        <div
          className="sx-bnr-1-wrap overlay-overlay"
          style={{
            backgroundImage: `url(${publicUrlFor(
              "images/services/service-detail-digital-marketing.jpg"
            )})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            minHeight: "85vh",
            display: "flex",
            alignItems: "center",
            backfaceVisibility: "hidden",
            backgroundBlendMode: "multiply",
            backgroundColor: "rgba(0, 0, 0, 0.15)",
          }}
        >
          <div className="sx-bg-overlay opacity-0 sx-bg-primary" />

          <div className="container">
            <div className="sx-bnr-1-content text-center">
              {/* H1 */}
              <h1
                style={{ fontSize: "7vw" }}
                className="sx-bnr-1-large-title fw-bolder text-light mb-3 "
              >
                Digital Marketing Services in Pune
              </h1>

              {/* H2 */}
              <h2 className="sx-bnr-1-info fs-4 text-light mb-4">
                Grow Your Brand, Website Traffic And Leads with Result-Driven
                Digital Marketing
              </h2>

              {/* CTA */}
              <div className="sx-bnr-readmore mt-4">
                <NavLink
                  to="/contact-us"
                  className="site-button sx-btn-primary icon"
                >
                  Request A Call
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        {/* Content Container */}
        <div className="container m-t50">
          <div className="section-content">
            <div className="sx-our-service-detail">
              {/* Section Header */}
              <div className="section-head2">
                <div className="sx-head-l-title">
                  <h2 className="sx-title2 text-center">
                    Performance-Focused Digital Marketing Services That Deliver
                    Results
                  </h2>
                </div>
              </div>

              {/* Intro Content */}
              <div className="sx-our-service-info m-b0 text-center">
                <p>
                  At <strong>DArch Tech</strong>, we deliver
                  <strong>
                    {" "}
                    data-driven and ROI-focused digital marketing services{" "}
                  </strong>
                  <br />
                  that help businesses grow online, attract the right audience,
                  and convert leads into loyal customers.
                </p>

                <p>
                  Whether you are a{" "}
                  <strong>startup, small business, or enterprise</strong>, our
                  digital marketing experts design customized strategies aligned
                  <br />
                  with your business goals, target audience, and competitive
                  landscape.
                </p>

                {/* Feature Icons */}
                <div className="sx-head-s-title h3 my-5 text-center">
                  Result-Driven Digital Marketing
                </div>
                <div className="row sx-about-icon-bx1-column p-t50 p-b20">
                  <div className="col-lg-3 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaChartLine size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Strategy-First Approach
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Customized Marketing Plans
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaArrowUpRightDots size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          ROI-Driven Campaigns
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Measurable Results
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaBullseye size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Targeted Marketing
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Audience Precision
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6 m-b30">
                    <div className="sx-icon-bx-2">
                      <div className="sx-media">
                        <FaFileAlt size={36} />
                      </div>
                      <div className="sx-icon-bx-info">
                        <span className="sx-icon-bx-title">
                          Transparent Reporting
                        </span>
                        <span className="sx-icon-bx-title-info">
                          Actionable Insights
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 className="sx-title2 text-center">
                  Our Digital Marketing Services Include
                </h3>

                <div className="row m-t70">
                  <div className="col-lg-4 col-md-6 m-b10">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Search Engine Optimization (SEO)
                      </h4>
                      <p>
                        Improve your Google rankings and generate long-term
                        organic leads through on-page, technical SEO, content
                        optimization, and link building.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Pay-Per-Click Advertising (Google Ads & Paid Media)
                      </h4>
                      <p>
                        Drive instant traffic and qualified leads with
                        high-performing PPC campaigns focused on conversions and
                        ROI.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Social Media Marketing & Management
                      </h4>
                      <p>
                        Build brand awareness, engagement, and leads across
                        platforms like Instagram, Facebook, and LinkedIn.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Content Marketing
                      </h4>
                      <p>
                        Create SEO-friendly content that educates, engages, and
                        supports long-term brand growth.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Email Marketing
                      </h4>
                      <p>
                        Nurture leads and retain customers through targeted and
                        personalized email campaigns.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Local SEO & Lead Generation
                      </h4>
                      <p>
                        Improve Google Maps visibility and attract
                        location-based customers.
                      </p>
                    </div>
                  </div>

                  {/* <div className="col-lg-4 col-md-6 m-b30">
                    <div
                      className="sx-service-card"
                      style={{
                        backgroundColor: "#ffffff",
                        border: "1px solid #d6edf2",
                        borderRadius: "8px",
                        padding: "25px",
                        height: "100%",
                      }}
                    >
                      <h4 style={{ color: "#116A7A", fontWeight: "600" }}>
                        Online Reputation Management
                      </h4>
                      <p>
                        Build trust and credibility by managing reviews,
                        ratings, and brand mentions.
                      </p>
                    </div>
                  </div> */}
                </div>
              </div>

              {/* Counters */}
              <SectionCounter1 />

              {/* FAQ SECTION START */}
              <div
                className="section-full p-t30 p-b80"
                style={{ backgroundColor: "#f5f8fa" }}
              >
                <div className="container">
                  {/* Section Heading */}
                  <div
                    className="section-head2 text-center"
                    style={{ color: "#116A7A" }}
                  >
                    <div className="sx-head-l-title">
                      <h2 className="sx-title2" style={{ color: "#116A7A" }}>
                        Digital Marketing Services FAQs
                      </h2>
                    </div>
                  </div>

                  {/* Accordion */}
                  <div
                    className="accordion sx-accordion"
                    id="digitalMarketingFaq"
                  >
                    <div
                      className="accordion sx-accordion"
                      id="digitalMarketingFaq"
                    >
                      {/* FAQ 1 */}
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="faqOneDM">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOneDM"
                            aria-expanded="true"
                            aria-controls="collapseOneDM"
                            style={{
                              backgroundColor: "#e0f0f3",
                              color: "#116A7A",
                              fontWeight: "600",
                            }}
                          >
                            How long does it take to see results from digital
                            marketing?
                          </button>
                        </h3>
                        <div
                          id="collapseOneDM"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#digitalMarketingFaq"
                        >
                          <div className="accordion-body">
                            Results depend on the strategy.{" "}
                            <strong>SEO may take 3–6 months</strong>, while{" "}
                            <strong>
                              paid campaigns can deliver results within weeks
                            </strong>
                            .
                          </div>
                        </div>
                      </div>

                      {/* FAQ 2 */}
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="faqTwoDM">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwoDM"
                            aria-expanded="true"
                            aria-controls="collapseTwoDM"
                            style={{
                              backgroundColor: "#e0f0f3",
                              color: "#116A7A",
                              fontWeight: "600",
                            }}
                          >
                            Do you offer customized digital marketing packages?
                          </button>
                        </h3>
                        <div
                          id="collapseTwoDM"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#digitalMarketingFaq"
                        >
                          <div className="accordion-body">
                            Yes. All our digital marketing solutions are
                            <strong>
                              {" "}
                              customized based on your business goals and budget
                            </strong>
                            .
                          </div>
                        </div>
                      </div>

                      {/* FAQ 3 */}
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="faqThreeDM">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseThreeDM"
                            aria-expanded="true"
                            aria-controls="collapseThreeDM"
                            style={{
                              backgroundColor: "#e0f0f3",
                              color: "#116A7A",
                              fontWeight: "600",
                            }}
                          >
                            Will I receive regular performance reports?
                          </button>
                        </h3>
                        <div
                          id="collapseThreeDM"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#digitalMarketingFaq"
                        >
                          <div className="accordion-body">
                            Yes. We provide
                            <strong>
                              {" "}
                              transparent monthly reports with key metrics and
                              insights
                            </strong>
                            .
                          </div>
                        </div>
                      </div>

                      {/* FAQ 4 */}
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="faqFourDM">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFourDM"
                            aria-expanded="true"
                            aria-controls="collapseFourDM"
                            style={{
                              backgroundColor: "#e0f0f3",
                              color: "#116A7A",
                              fontWeight: "600",
                            }}
                          >
                            Do you work with local businesses?
                          </button>
                        </h3>
                        <div
                          id="collapseFourDM"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#digitalMarketingFaq"
                        >
                          <div className="accordion-body">
                            Absolutely. We specialize in
                            <strong> local SEO and lead generation</strong> for
                            businesses targeting specific locations.
                          </div>
                        </div>
                      </div>

                      {/* FAQ 5 */}
                      <div className="accordion-item">
                        <h3 className="accordion-header" id="faqFiveDM">
                          <button
                            className="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseFiveDM"
                            aria-expanded="true"
                            aria-controls="collapseFiveDM"
                            style={{
                              backgroundColor: "#e0f0f3",
                              color: "#116A7A",
                              fontWeight: "600",
                            }}
                          >
                            Can you manage both organic and paid marketing?
                          </button>
                        </h3>
                        <div
                          id="collapseFiveDM"
                          className="accordion-collapse collapse show"
                          data-bs-parent="#digitalMarketingFaq"
                        >
                          <div className="accordion-body">
                            Yes. We handle
                            <strong>
                              {" "}
                              SEO, content marketing, paid ads, and social media
                            </strong>{" "}
                            under one roof.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* FAQ SECTION END */}
            </div>
          </div>
        </div>
      </div>
      {/* SERVICE DETAIL SECTION END */}

      {/* Supporting Sections */}
      {/* <SectionVideo2 /> */}
      {/* <SectionWhyChooseUs4 /> */}
      {/* <SectionClients2 /> */}
    </>
  );
}

export default DigitalMarketingServicePage;
